import { FormInstance, Radio, RadioChangeEvent } from "antd";
import { useCallback } from "react";
import { FluidPayACHOption } from "./FluidPayACHOption";
import { DefaultOption } from "./DefaultOption";

type OptionsProps = {
  form: FormInstance;
  selectedOption: string;
  title: string;
  data: any[];
  providerOptions: any;
  selectedItem: any;
  setRequest: React.Dispatch<React.SetStateAction<any>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  onDeleted: (id: string) => void;
};

export const Options = ({
  form,
  selectedOption,
  title,
  data,
  providerOptions,
  selectedItem,
  setRequest,
  setSelectedOption,
  onDeleted,
}: OptionsProps) => {
  const onSelect = useCallback(
    (e: RadioChangeEvent) => setSelectedOption(e.target.value),
    [setSelectedOption],
  );

  return (
    <Radio.Group
      className="methods w-100"
      value={selectedOption}
      onChange={onSelect}
    >
      {data.map((option: any) => (
        <DefaultOption
          selectedItem={selectedItem}
          key={option.id}
          option={option}
          title={title}
          onDeleted={onDeleted}
        />
      ))}
      {selectedItem.providerName === "FluidPay" &&
        selectedItem.methodType === 1 && (
          <FluidPayACHOption
            form={form}
            title={title}
            providerOptions={providerOptions}
            selectedOption={selectedOption}
            setRequest={setRequest}
          />
        )}
    </Radio.Group>
  );
};
